import { render, staticRenderFns } from "./lookImg.vue?vue&type=template&id=3bfb4536&scoped=true&"
import script from "./lookImg.vue?vue&type=script&lang=js&"
export * from "./lookImg.vue?vue&type=script&lang=js&"
import style0 from "./lookImg.vue?vue&type=style&index=0&id=3bfb4536&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfb4536",
  null
  
)

export default component.exports